import React, { useEffect, useState } from "react";
import { Modal, Input, message, Spin, Form } from "antd";
import { useUserContext } from "../context/dashboard-context";
import CustomPagination from "../components/pagination";
import BigProjectImageUploader from "../components/imageUploader/BigProjectImageUploader";
import api from "../context/api";
import BigProjectCard from '../components/bigproject/BigProjectCard';
import './bigprojects.scss';

const { TextArea } = Input;

const BigProjectsPage = () => {
  const { token } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [bigProjects, setBigProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalProjects, setTotalProjects] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const [formData, setFormData] = useState({
    title_uz: "",
    title_ru: "",
    title_en: "",
    text_uz: "",
    text_ru: "",
    text_en: "",
    imageFile: null
  });

  const fetchBigProjects = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(`/bigproject/?page=${page}`);
  
      const data = Array.isArray(response.data) ? response.data : response.data.data || [];
      setBigProjects(data);
      setTotalProjects(response.data.totalCount || response.data.count || data.length);
  
    } catch (error) {
      console.error("Error fetching big projects:", error);
      message.error("Katta loyihalarni yuklashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };
  

  const addBigProject = async () => {
    if (!formData.imageFile) {
      message.error("Iltimos, rasm yuklang");
      return;
    }

    setLoading(true);
    const formDataToSend = new FormData();
    
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== 'imageFile' && value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });
    
    if (formData.imageFile) {
      formDataToSend.append("image", formData.imageFile);
    }

    try {
      const response = await api.post("/bigproject/", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if ([200, 201].includes(response.status)) {
        message.success("Katta loyiha muvaffaqiyatli qo'shildi");
        fetchBigProjects(currentPage);
        form.resetFields();
        setFormData({
          title_uz: "",
          title_ru: "",
          title_en: "",
          text_uz: "",
          text_ru: "",
          text_en: "",
          imageFile: null
        });
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error adding big project:", error);
      message.error(error.response?.data?.message || "Katta loyiha qo'shishda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBigProjects();
  }, []);

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="bigprojects-page">
      <div className="page-header">
        <h1>Katta Loyihalar</h1>
        <button onClick={() => setIsModalOpen(true)}>
          + Yangi loyiha qo'shish
        </button>
      </div>

      {loading && bigProjects.length === 0 ? (
        <Spin size="large" />
      ) : bigProjects.length > 0 ? (
        <>
          <div className="bigprojects-grid">
            {bigProjects.map(project => (
              <BigProjectCard
                key={project.id}
                project={project}
                onUpdate={fetchBigProjects}
              />
            ))}
          </div>
          
          <CustomPagination
            current={currentPage}
            total={totalProjects}
            onChange={(page) => {
              setCurrentPage(page);
              fetchBigProjects(page);
            }}
          />
        </>
      ) : (
        <div className="no-projects">
          <p>Hozircha katta loyihalar mavjud emas. Birinchi loyihani qo'shing.</p>
        </div>
      )}

      <Modal
        title="Yangi katta loyiha qo'shish"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
        }}
        footer={null}
        width={800}
      >
        <Spin spinning={loading}>
          <Form form={form} onFinish={addBigProject}>
            <div className="form-section">
            <Form.Item label="Sarlavha (O'zbekcha)" required={false}>
                <Input
                  value={formData.title_uz}
                  onChange={(e) => handleFormChange('title_uz', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Sarlavha (Ruscha)" required={false}>
                <Input
                  value={formData.title_ru}
                  onChange={(e) => handleFormChange('title_ru', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Sarlavha (Inglizcha)" required={false}>
                <Input
                  value={formData.title_en}
                  onChange={(e) => handleFormChange('title_en', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Matn (O'zbekcha)" required={false}>
                <TextArea
                  rows={4}
                  value={formData.text_uz}
                  onChange={(e) => handleFormChange('text_uz', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Matn (Ruscha)" required={false}>
                <TextArea
                  rows={4}
                  value={formData.text_ru}
                  onChange={(e) => handleFormChange('text_ru', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Matn (Inglizcha)" required={false}>
                <TextArea
                  rows={4}
                  value={formData.text_en}
                  onChange={(e) => handleFormChange('text_en', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Rasm" required>
                <BigProjectImageUploader
                  imageFile={formData.imageFile}
                  setImageFile={(file) => handleFormChange('imageFile', file)}
                />
              </Form.Item>
            </div>
            
            <div className="form-actions">
              <button 
                type="button"
                className="cancel-btn"
                onClick={() => setIsModalOpen(false)}
              >
                Bekor qilish
              </button>
              <button 
                type="submit"
                className="submit-btn"
                disabled={!formData.imageFile}
              >
                Loyiha qo'shish
              </button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default BigProjectsPage;